import type { PublicLanguage } from "./i18n";

export type LicenseSupportOption = "license-renewal" | "educational-records-verification" | "new-license-application" | "exam-registration" | "other";

const licenseSupportLinkOptions: Array<[string, LicenseSupportOption]> = [
  ["LRS", "license-renewal"],
  ["ERV", "educational-records-verification"],
  ["NLA", "new-license-application"],
  ["ER", "exam-registration"],
  ["O", "other"],
];

const publicLanguages = new Set<PublicLanguage>(["en", "zh", "th", "my", "vi", "es"]);

export function licenseSupportSelectionsFromSearch(search: string): LicenseSupportOption[] {
  const parameters = new URLSearchParams(search);
  // Accept both conventional query parameters and the compact links already
  // used in outreach, such as ?LRS=1,ERV=0,NLA=1,O=0&lang=es.
  const compact = Object.fromEntries(
    [...search.matchAll(/(?:[?&,])([A-Za-z]+)=([01])(?=,|&|$)/g)]
      .map(([, key, value]) => [key.toUpperCase(), value]),
  );
  return licenseSupportLinkOptions
    .filter(([key]) => parameters.get(key) === "1" || compact[key] === "1")
    .map(([, option]) => option);
}

export function languageFromSearch(search: string): PublicLanguage | undefined {
  const parameters = new URLSearchParams(search);
  const value = parameters.get("lang") || parameters.get("language");
  return publicLanguages.has(value as PublicLanguage) ? value as PublicLanguage : undefined;
}

export function promotionCodeFromSearch(search: string): string {
  const parameters = new URLSearchParams(search);
  return (parameters.get("promo") || parameters.get("promotion") || "")
    .trim()
    .toUpperCase()
    .slice(0, 40);
}
